/**
 * package: com.inq.flash.messagingframework
 * class: FlashMessagingFramework
 * root Object
 * @constructor
 */
com.inq.flash.messagingframework.FlashMessagingFramework = function(applicationController) {
	haxe.Log.trace("entered",{ fileName : "FlashMessagingFramework.hx", lineNumber : 60, className : "com.inq.flash.messagingframework.FlashMessagingFramework", methodName : "new"});
	this.params = [];
	this.maxConnectionRetries = 100;
	this.connectionHandlerAttemptIndex = -1;
	haxe.Log.trace("request for new MessageRouter()",{ fileName : "FlashMessagingFramework.hx", lineNumber : 64, className : "com.inq.flash.messagingframework.FlashMessagingFramework", methodName : "new"});
	this.messageRouter = new com.inq.flash.messagingframework.MessageRouter();
	haxe.Log.trace("requested  new MessageRouter()",{ fileName : "FlashMessagingFramework.hx", lineNumber : 66, className : "com.inq.flash.messagingframework.FlashMessagingFramework", methodName : "new"});
	this.applicationConnectionEventHandler = new com.inq.flash.client.control.ClientConnectionEventHandler(applicationController);
	this.connectionHandlers = [];
	/** @type {?string} */
	var httpHost = com.inq.flash.client.control.FlashVars.getValue("submitURL");
	var connectionHandler = new com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler(httpHost,com.inq.flash.client.control.FlashVars.getValue("chatID"),this.params, applicationController);
	this.setupConnection(connectionHandler, 0);
	haxe.Log.trace("exit",{ fileName : "FlashMessagingFramework.hx", lineNumber : 112, className : "com.inq.flash.messagingframework.FlashMessagingFramework", methodName : "new"});
};
$hxClasses['com.inq.flash.messagingframework.FlashMessagingFramework'] = com.inq.flash.messagingframework.FlashMessagingFramework;
/** @private @type {Array} */
com.inq.flash.messagingframework.FlashMessagingFramework.__name__ = ["com","inq","flash","messagingframework","FlashMessagingFramework"];

/**
 * sendMessage
 *
 * $type TFun([{ name => message, t => TInst(com.inq.flash.messagingframework.Message,[]), opt => false }],TEnum(Void,[]))
 * @public
 * @this com.inq.flash.messagingframework.FlashMessagingFramework
 * @param {com.inq.flash.messagingframework.Message}  message
 * @param {function} successListener Optional callback function on success message delivery.
 * @param {function} errorListener Optional callback function on error message delivery.
 * @return {void}
 */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.sendMessage = function (message, successListener, errorListener) {
	haxe.Log.trace("in FMF.sendMessage: " + message.toString(), {
		fileName: "FlashMessagingFramework.js", lineNumber: 86, methodName: "sendMessage",
		className: "com.inq.flash.messagingframework.FlashMessagingFramework"
	});

	if (this.selectedConnectionHandler != null) {
		this.selectedConnectionHandler.sendMessage(message, successListener, errorListener);
	} else {
		var errorMessage = "Message was not sent, selectedConnectionHandler === null. Message: " + message.toString();
		var error = new Error("FlashMessagingFramework.prototype.sendMessage: no connection handler");
		com.inq.flash.client.control.FlashPeer.logError(errorMessage, error);
	}
};

/**
 * Start listen for messages after successful CHAT.REQUEST.
 * CI doesn't listen for the messages until successful CHAT.REQUEST.
 *
 * @return {void}
 */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.startListenForMessages = function () {
	this.getConnection().listenForMessages();
};

/**
 * Sends request to get transcript from chatrouter
 */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.getMessages = function () {
	this.getConnection().getMessages();
};

/**
 * Sends communication message from queue in connection handler.
 */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.sendCommunicationMessagesFromQueue = function () {
	this.getConnection().sendCommunicationMessagesFromQueue();
};

/**
 * Sends reconnect GET message after successful CHAT.REQUEST.RECONNECT
 */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.sendReconnectGetMessage = function () {
	this.getConnection().sendReconnectGetMessage();
};


/**
 * Returns the boolean flag meaning that chat application can communicate with the chat router.
 *
 * @public
 * @this com.inq.flash.messagingframework.FlashMessagingFramework
 * @return {boolean}
 */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.isConnected = function() {
	if(this.selectedConnectionHandler == null) return false;
	return this.selectedConnectionHandler.isConnected();
};

/**
 * Returns true if last message returned fail status to mark that there is no network connection
 * @return {Boolean}
 */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.isSendMessageFail = function() {
	if (this.selectedConnectionHandler) {
		return this.selectedConnectionHandler.isSendMessageFail();
	}
};

/**
 * Response timestamp is used for detection the last successful response from the server
 * to monitor the time of the connection issue.
 * If returns 0 that means the response had not received even once.
 * @returns {number}
 */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype._getResponseTimestamp = function() {
	if (this.selectedConnectionHandler) {
		return this.selectedConnectionHandler._getResponseTimestamp();
	}
};

/**
 * disconnect
 *
 * $type TFun([],TEnum(Void,[]))
 * public function disconnect():Void
 * @public
 * @this com.inq.flash.messagingframework.FlashMessagingFramework
 * @param {string} reason
 * @return {void}
 */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.disconnect = function(reason) {
	if(this.selectedConnectionHandler != null) this.selectedConnectionHandler.disconnect(reason);
};


/**
 * abortingConnectionAttempt
 *
 * $type TFun([],TEnum(Void,[]))
 * public function abortingConnectionAttempt():Void
 * @public
 * @this com.inq.flash.messagingframework.FlashMessagingFramework
 * @return {void}
 */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.abortingConnectionAttempt = function() {
	this.applicationConnectionEventHandler.allConnectionAttemptsFailed();
};


/**
 * connectionFailed
 *
 * $type TFun([],TEnum(Bool,[]))
 * public function connectionFailed():Bool
 * @public
 * @this com.inq.flash.messagingframework.FlashMessagingFramework
 * @return {boolean}
 */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.connectionFailed = function() {
	if(this.selectedConnectionHandler != null) {
		this.connectionRetryAttempts++;
		if(this.connectionRetryAttempts < this.maxConnectionRetries) return this.applicationConnectionEventHandler.connectionFailedNeedRetryRequest(this.connectionRetryAttempts,this.maxConnectionRetries); else {
			this.abortingConnectionAttempt();
			return false;
		}
	} else if(this.applicationConnectionEventHandler.connectionFailedNeedRetryRequest(this.connectionRetryAttempts,this.maxConnectionRetries)) {
		this.selectNextConnectionHandler();
		return false;
	}
	return false;
};


/**
 * connectionSuccesful
 *
 * $type TFun([{ name => connectionHandler, t => TInst(com.inq.flash.messagingframework.connectionhandling.ConnectionHandler,[]), opt => false }],TEnum(Void,[]))
 * public function connectionSuccesful(connectionHandler:ConnectionHandler):Void
 * @public
 * @this com.inq.flash.messagingframework.FlashMessagingFramework
 * @param {com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler}  connectionHandler
 * @return {void}
 */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.connectionSuccesful = function(connectionHandler) {
	this.selectedConnectionHandler = connectionHandler;
	this.connectionRetryAttempts = 0;
};

/**
 * getConnection
 *
 * public function getConnection()
 * @public
 * @this com.inq.flash.messagingframework.FlashMessagingFramework
 * @return {HTTPConnectionHandler}
 */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.getConnection = function() {
	return this.selectedConnectionHandler || null;
};

/**
 * getConnectionType
 *
 * $type TFun([],TInst(String,[]))
 * public function getConnectionType():String
 * @public
 * @this com.inq.flash.messagingframework.FlashMessagingFramework
 * @return {string}
 */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.getConnectionType = function() {
	if(this.selectedConnectionHandler == null) return null;
	return this.selectedConnectionHandler.getConnectionType();
};


/**
 * selectNextConnectionHandler
 *
 * $type TFun([],TEnum(Void,[]))
 * private function selectNextConnectionHandler():Void
 * @private
 * @this com.inq.flash.messagingframework.FlashMessagingFramework
 * @return {void}
 */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.selectNextConnectionHandler = function() {
	this.connectionHandlerAttemptIndex++;
	if(this.connectionHandlerAttemptIndex >= this.connectionHandlers.length) this.connectionHandlerAttemptIndex = 0;
	this.connectionRetryAttempts++;
	if(this.connectionRetryAttempts < this.maxConnectionRetries) {
		/** @type {com.inq.flash.messagingframework.connectionhandling.ConnectionHandler} */
		var connectionHandler = js.Boot.__cast(this.connectionHandlers[this.connectionHandlerAttemptIndex] , com.inq.flash.messagingframework.connectionhandling.ConnectionHandler);
		if(this.newHost != null && this.newHost != "") connectionHandler.setHost(this.newHost);
		connectionHandler.connect();
	} else this.abortingConnectionAttempt();
};


/**
 * acknowledgePersistentActive
 *
 * $type TFun([{ name => chatID, t => TInst(String,[]), opt => false },{ name => protoDomain, t => TInst(String,[]), opt => false },{ name => clientProtoDomain, t => TInst(String,[]), opt => false },{ name => needNewOpener, t => TEnum(Bool,[]), opt => false },{ name => messageCnt, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public function acknowledgePersistentActive(chatID:String, protoDomain:String, clientProtoDomain:String, needNewOpener:Bool, messageCnt:String)
 * @public
 * @this com.inq.flash.messagingframework.FlashMessagingFramework
 * @param {string}  chatID 
 * @param {string}  protoDomain 
 * @param {string}  clientProtoDomain 
 * @param {boolean}  needNewOpener 
 * @return {void}
 */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.acknowledgePersistentActive = function (chatID, protoDomain, clientProtoDomain, needNewOpener) {
    if (this.selectedConnectionHandler != null && !(com.inq.flash.client.control.FlashVars.getValue("isCachePersistentUsed") === "true")) {
        this.selectedConnectionHandler.acknowledgePersistentActive(chatID, protoDomain, clientProtoDomain, needNewOpener);
    }
};

/**
 * acknowledgeChatActive
 *
 * $type TFun([{ name => chatID, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public function acknowledgeChatActive(chatID:String)
 * @public
 * @this com.inq.flash.messagingframework.FlashMessagingFramework
 * @param {string}  chatID 
 * @return {void}
 */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.acknowledgeChatActive = function(chatID) {
	if(this.selectedConnectionHandler != null) this.selectedConnectionHandler.acknowledgeChatActive(chatID);
};

/**
 * Try to restore chat on server.
 */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.handleChatLost = function () {
	if (this.selectedConnectionHandler !== null) {
		this.selectedConnectionHandler.handleChatLost();
	}
};

/**
 * enable
 *
 * $type TFun([],TEnum(Void,[]))
 * public function enable():Void
 * @public
 * @this com.inq.flash.messagingframework.FlashMessagingFramework
 * @return {void}
 */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.enable = function() {
	if(this.selectedConnectionHandler != null) this.selectedConnectionHandler.enable();
};

com.inq.flash.messagingframework.FlashMessagingFramework.prototype.enableForReEngaging = function() {
	if(this.selectedConnectionHandler != null) this.selectedConnectionHandler.enableForReEngaging();
};

/**
 * disable
 *
 * $type TFun([],TEnum(Void,[]))
 * public function disable():Void
 * @public
 * @this com.inq.flash.messagingframework.FlashMessagingFramework
 * @return {void}
 */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.disable = function() {
	if(this.selectedConnectionHandler != null) this.selectedConnectionHandler.disable();
};

/**
 * connect
 *
 * $type TFun([],TEnum(Void,[]))
 * public function connect():Void
 * @public
 * @this com.inq.flash.messagingframework.FlashMessagingFramework
 * @return {void}
 */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.connect = function() {
	haxe.Log.trace("enter connect",{ fileName : "FlashMessagingFramework.hx", lineNumber : 146, className : "com.inq.flash.messagingframework.FlashMessagingFramework", methodName : "connect"});
	this.connectionHandlerAttemptIndex = -1;
	haxe.Log.trace("in FMF connect()",{ fileName : "FlashMessagingFramework.hx", lineNumber : 148, className : "com.inq.flash.messagingframework.FlashMessagingFramework", methodName : "connect"});
	if(this.selectedConnectionHandler == null) this.selectedConnectionHandler = this.connectionHandlers[0];
	if(this.selectedConnectionHandler != null) {
		haxe.Log.trace("selectedConnectionHandler.connect()",{ fileName : "FlashMessagingFramework.hx", lineNumber : 153, className : "com.inq.flash.messagingframework.FlashMessagingFramework", methodName : "connect"});
		this.selectedConnectionHandler.connect();
	} else {
		haxe.Log.trace("selectNextConnectionHandler()",{ fileName : "FlashMessagingFramework.hx", lineNumber : 158, className : "com.inq.flash.messagingframework.FlashMessagingFramework", methodName : "connect"});
		this.selectNextConnectionHandler();
	}
	haxe.Log.trace("exit",{ fileName : "FlashMessagingFramework.hx", lineNumber : 161, className : "com.inq.flash.messagingframework.FlashMessagingFramework", methodName : "connect"});
};


/**
 * registerMessageHandler
 *
 * $type TFun([{ name => messageHandler, t => TInst(com.inq.flash.messagingframework.AbstractMessageHandler,[]), opt => false }],TEnum(Void,[]))
 * public function registerMessageHandler(messageHandler:AbstractMessageHandler):Void
 * @public
 * @this com.inq.flash.messagingframework.FlashMessagingFramework
 * @param {com.inq.flash.messagingframework.AbstractMessageHandler}  messageHandler 
 * @return {void}
 */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.registerMessageHandler = function(messageHandler) {
	this.messageRouter.registerMessageHandler(messageHandler);
	messageHandler.setMessagingFramework(this);
};

/**
 * processMessage
 *
 * $type TFun([{ name => messageHandler, t => TInst(com.inq.flash.messagingframework.AbstractMessageHandler,[]), opt => false }],TEnum(Void,[]))
 * public function processMessage(message:Message):Void
 * @public
 * @this com.inq.flash.messagingframework.FlashMessagingFramework
 * @param {com.inq.flash.messagingframework.Message}  message
 * @return {void}
 */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.processMessage = function(message) {
    this.messageRouter.processMessage(message);
};

/**
 * setupConnection
 *
 * $type TFun([{ name => connectionHandler, t => TInst(com.inq.flash.messagingframework.connectionhandling.ConnectionHandler,[]), opt => false },{ name => index, t => TInst(Int,[]), opt => false }],TEnum(Void,[]))
 * private function setupConnection(connectionHandler: ConnectionHandler, index:Int):Void
 * @private
 * @this com.inq.flash.messagingframework.FlashMessagingFramework
 * @param {com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler}  connectionHandler
 * @param {number}  index 
 * @return {void}
 */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.setupConnection = function(connectionHandler,index) {
	haxe.Log.trace("enter",{ fileName : "FlashMessagingFramework.hx", lineNumber : 130, className : "com.inq.flash.messagingframework.FlashMessagingFramework", methodName : "setupConnection"});
	
	connectionHandler.setApplicationConnectionEventHandler(this.applicationConnectionEventHandler);
	connectionHandler.setMessageRouter(this.messageRouter);
	connectionHandler.setMessagingFramework(this);
	this.connectionHandlers[index] = connectionHandler;
	haxe.Log.trace("exit: " + this.connectionHandlers.length,{ fileName : "FlashMessagingFramework.hx", lineNumber : 136, className : "com.inq.flash.messagingframework.FlashMessagingFramework", methodName : "setupConnection"});
};

/**
 * setParam
 *
 * $type TFun([{ name => field, t => TInst(String,[]), opt => false },{ name => value, t => TDynamic(null), opt => false }],TEnum(Void,[]))
 * public function setParam(field:String, value:Dynamic):Void
 * @public
 * @this com.inq.flash.messagingframework.FlashMessagingFramework
 * @param {string}  field 
 * @param {null}  value 
 * @return {void}
 */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.setParam = function(field,value) {
	if(null != this.selectedConnectionHandler) this.selectedConnectionHandler.setParam(field,value); else this.params[field] = value;
};

com.inq.flash.messagingframework.FlashMessagingFramework.prototype.getMessageHandlerByPrefix = function(messageType) {
	return this.messageRouter.getHandlerByPrefix(messageType);
};

/** @private @type {com.inq.flash.messagingframework.connectionhandling.HTTPConnectionHandler} */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.selectedConnectionHandler = null;
/** @private @type {number} */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.connectionHandlerAttemptIndex = null;
/** @private @type {Array} */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.connectionHandlers = null;
/** @private @type {string} */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.newHost = null;
/** @private @type {null} */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.params = null;
/** @private @type {number} */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.maxConnectionRetries = null;
/** @private @type {number} */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.connectionRetryAttempts = null;
/** @private @type {com.inq.flash.messagingframework.MessageRouter} */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.messageRouter = null;
/** @private @type {com.inq.flash.messagingframework.connectionhandling.ApplicationConnectionEventHandler} */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.applicationConnectionEventHandler = null;
/** @type {com.inq.flash.messagingframework.FlashMessagingFramework} */
com.inq.flash.messagingframework.FlashMessagingFramework.prototype.__class__ = com.inq.flash.messagingframework.FlashMessagingFramework;
/** @type {string} */
com.inq.flash.messagingframework.FlashMessagingFramework.CONNECTION_TYPE_HTTP = "http";

